export default __webpack_public_path__ + "static/media/assistant_tip.602282fd.png";